import { createRoot } from "react-dom/client"
import "./index.scss"
import "./custom.css"
import reportWebVitals from "./reportWebVitals"
import "./css/index.css"
import AppProvider from "./providers/AppProvider"
import "bootstrap-icons/font/bootstrap-icons.css"
import { ViewModeProvider } from "./context/ViewModeContext"
import { PinnedSidebarProvider } from "./context/PinnedSidebarContext"
import { FormatProvider } from "./context/FormatContext"
import ExtensionRuntimeProvider from "./components/ExtensionRuntimeProvider"

/**
 * Get a normalized favicon file name with extension.
 *
 * @param {string | undefined} faviconName Raw favicon value from env.
 * @returns {string} Normalized favicon filename.
 */
const getNormalizedFaviconName = (faviconName) => {
    if (!faviconName) {
        return ""
    }

    const trimmedFaviconName = faviconName.trim()
    if (!trimmedFaviconName) {
        return ""
    }

    if (trimmedFaviconName.includes(".")) {
        return trimmedFaviconName
    }

    return `${trimmedFaviconName}.png`
}

const favicon = getNormalizedFaviconName(process.env.REACT_APP_FAVICON) || "envsg-favicon.png"
const faviconPath = `${process.env.PUBLIC_URL || ""}/${favicon}`

const faviconElement = document.getElementById("favicon")
if (faviconElement) {
    faviconElement.href = faviconPath
}

const appleFaviconElement = document.getElementById("apple-favicon")
if (appleFaviconElement) {
    appleFaviconElement.href = faviconPath
}

const assetContainer = document.getElementById("root")
const root = createRoot(assetContainer)

root.render(
    <AppProvider>
        <FormatProvider>
            <ViewModeProvider>
                <PinnedSidebarProvider>
                    <ExtensionRuntimeProvider />
                </PinnedSidebarProvider>
            </ViewModeProvider>
        </FormatProvider>
    </AppProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
